module.exports = __webpack_public_path__ + "img/mail_success.b8e1ed6f.svg";